const equal = (x, y) => {
    if (Object.is(x, y)) {
        return true;
    }
    if (!(x instanceof Object) ||
        !(y instanceof Object) ||
        x.constructor !== y.constructor) {
        return false;
    }
    for (const props in x) {
        if (!Object.prototype.hasOwnProperty.call(x, props) ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Object.is(x[props], y[props])) {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(y, props) ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            typeof x[props] !== 'object' ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            !equal(x[props], y[props])) {
            return false;
        }
    }
    for (const props in y) {
        if (Object.prototype.hasOwnProperty.call(y, props) &&
            !Object.prototype.hasOwnProperty.call(x, props)) {
            return false;
        }
    }
    return true;
};
const equalTo = (x) => {
    return (y) => {
        return equal(x, y);
    };
};
export { equal, equalTo };
//# sourceMappingURL=equal.js.map